export class CompetitiveService {
    constructor() {
        const contentTitleElement = document.querySelector(".content-title__heading");
        const phoneNumberContainerElements = document.querySelectorAll(".phone-numbers li");
        const phoneNumbersElements = document.querySelectorAll(".phone-numbers span[class^='callNow']");
        const fontFamilyBold = getComputedStyle(contentTitleElement).fontFamily;
        const fontFamilyNormal = getComputedStyle(phoneNumbersElements[0]).fontFamily;
        phoneNumberContainerElements.forEach((phoneNumberElement) => {
            phoneNumberElement.style.fontFamily = fontFamilyBold;
        });
        phoneNumbersElements.forEach((phoneNumberElement) => {
            phoneNumberElement.style.fontFamily = fontFamilyNormal;
        });
    }
}
window.DoUtility.SelfInstantiateOnLoad(CompetitiveService);
